import { Token } from 'config/types'
import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import { useIsDisabledFeaturedOnTelegram } from 'hooks/useTelegram'
import { useTokenInfo, useValidateWithdrawToken } from 'state/app/hooks'
import { isFiatNetwork, isHPNNetwork } from 'utils/network'
import WarningOnTelegram from 'views/Authentication/components/Wallet/WarningOnTelegram/WarningOnTelegram'
import HUSDInfo from 'views/Payment/components/HUSDInfo'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { PaymentCurrencyBlockMessage } from '../components/styles'
import WithdrawCryptos from './WithdrawCryptos'
import WithdrawFiat from './WithdrawFiat'

const WithdrawForm: React.FC<{
  selectedToken: Token
  onBack: () => void
  onClose: () => void
  onRedirectToSwap: () => void
  bonusControl: {
    bonuses: WageringConditionBonus[]
  }
}> = ({ selectedToken, onBack, onClose, onRedirectToSwap, bonusControl }) => {
  const currencyInfo = useTokenInfo(selectedToken)
  const { isBlackList, isLogicLocked } = useValidateWithdrawToken(selectedToken)
  const isDisabledFeaturedOnTelegram = useIsDisabledFeaturedOnTelegram()

  return isDisabledFeaturedOnTelegram ? (
    <WarningOnTelegram />
  ) : (
    selectedToken &&
      (!currencyInfo || currencyInfo?.disabledWithdrawal || isBlackList ? (
        <PaymentCurrencyBlockMessage currency={selectedToken} page={PaymentPageEnums.Withdraw} />
      ) : isLogicLocked ? (
        <PaymentCurrencyBlockMessage currency={selectedToken} page={PaymentPageEnums.Withdraw} reason="locked" />
      ) : isHPNNetwork(selectedToken.network) ? (
        <HUSDInfo onRedirectToSwap={onRedirectToSwap} />
      ) : isFiatNetwork(selectedToken.network) ? (
        <WithdrawFiat onBack={onBack} onClose={onClose} selectedToken={selectedToken} />
      ) : (
        <WithdrawCryptos onBack={onBack} onClose={onClose} selectedToken={selectedToken} bonusControl={bonusControl} />
      ))
  )
}

export default WithdrawForm
